import { createFileRoute } from "@tanstack/react-router";
import ReguliPublicare from "@/pages/incredere/ReguliPublicare";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/incredere/reguli-publicare/")({
  head: () => routeHead("/incredere/reguli-publicare/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <ReguliPublicare />
  );
}
